var _path, _path2, _path3, _circle;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgNetwork24(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M17.25 3.78273C15.7345 2.81249 13.933 2.25 12 2.25C6.61522 2.25 2.25 6.61522 2.25 12C2.25 17.3848 6.61522 21.75 12 21.75C17.3848 21.75 21.75 17.3848 21.75 12C21.75 10.6686 21.4831 9.39956 21 8.2434C20.7519 7.64978 20.0916 6.55868 20.0916 6.55868",
    stroke: "current",
    strokeWidth: 1.5
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M15.75 12C15.75 14.7124 14.6942 17.2023 13.6046 19.0425C13.0629 19.9575 12.521 20.6981 12.1158 21.2085C12.0758 21.2589 12.0371 21.3069 12 21.3527C11.9629 21.3069 11.9242 21.2589 11.8842 21.2085C11.479 20.6981 10.9371 19.9575 10.3954 19.0425C9.30582 17.2023 8.25 14.7124 8.25 12C8.25 9.28763 9.30582 6.79773 10.3954 4.95748C10.9371 4.04254 11.479 3.3019 11.8842 2.79151C11.9242 2.74115 11.9629 2.69306 12 2.6473C12.0371 2.69306 12.0758 2.74115 12.1158 2.79151C12.521 3.3019 13.0629 4.04254 13.6046 4.95748C14.6942 6.79773 15.75 9.28763 15.75 12Z",
    stroke: "current",
    strokeWidth: 1.5
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M3 9H21M3 15H21",
    stroke: "current",
    strokeWidth: 1.5
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 18.75,
    cy: 5.25,
    r: 0.75,
    className: "filled",
    fill: "current",
    strokeWidth: 0
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgNetwork24);
export default __webpack_public_path__ + "static/media/Network-24.6591f6dc.svg";
export { ForwardRef as ReactComponent };